module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-100-active-bft-156b1069a656579bd678229e5f8c08ae.png";